import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../logo.png";
const as = [
  { name: "Contact us", href: "/contact_us" },
  { name: "About us", href: "/about_us" },
  { name: "Privacy Policy", href: "/privacy_policy" },
  { name: "Terms & Conditions", href: "/terms_conditions" },
  { name: "Our Founder", href: "/our_founder" },
  // { name: "FAQ", href: "/faq" },
];

/**
 * 站点公共页脚，提供联系信息与常用页面入口。
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="creatyea-padding main-site-footer">
      <Container className="text-center py-3">
        <Row className="row">
          <div className="col-lg-12">
            <div className="padded-div">
              <Link className="footer-site-logo" to="/">
                <Image src={logo} alt="Creatyea" />
              </Link>
            </div>
          </div>
        </Row>
        <Row className="row text-left">
          <Col className="col-lg-4">
            <div className="padded-div">
              <p>
                We are here to assist you. Feel free to reach out to us by email
                or give us a call during our office hours.
              </p>
            </div>
            <Row className="row">
              <Col className="col-md-12">
                <table className="invisible-table">
                  <tbody>
                    <tr>
                      <td>
                        <p className="footer-element-max-width">
                          Creatyea Technology (SZ) CO Limited, RM1903 - 1905,
                          19/F, Qiu Shi, West BLDG, Zhu Zi Lin, Fu Tian Estate,
                          Shen Zhen, 518031 GD, China.
                        </p>
                        <p className="footer-element-max-width">
                          <Link to="mailto:hello@creatyea.com"></Link>
                          <br />
                          <Link to="tel:+86075523968544">+86(0)75523968544</Link>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </Col>
          <Col className="col-lg-4 left-padding-in-desktop">
            <div className="flex flex-col items-start gap-2">
              <h4 className="mini-heading">Information</h4>
              <ul className="flex gap-2 flex-col items-start">
                {as.map((a, index) => (
                  <li key={index}>
                    <Link to={a.href}>{a.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
          <Col className="col-lg-4">
            <div className="padded-div flex flex-col gap-12">
              <div className="flex flex-col items-start gap-2">
                <h4 className="mini-heading">Follow us on</h4>
                <div className="flex gap-2">
                  <Link to="https://www.facebook.com/creatyea">
                    <Image src="/img/facebook_logo.png" alt="" />
                  </Link>
                  <Link to="https://www.instagram.com/creatyea/">
                    <Image src="/img/instagram_logo.png" alt="" />
                  </Link>
                </div>
              </div>
              <div className="flex flex-col items-start gap-2">
                <h4 className="mini-heading">Encrypted Payment</h4>
                <div className="flex gap-2">
                  <Image src="/img/paypal_logo.png" alt="" />
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row className="row">
          <div className="col-span-12 text-center">
            <p className="mb-2">
              &copy; {currentYear} Creatyea Technology (SZ) CO Limited. All
              rights reserved.
            </p>
            {/* <Link
              to="https://api.whatsapp.com/send?phone=16198601769"
              className="text-blue-500 hover:text-blue-700"
            >
              Daoud Developer - This Web Developer Site Mern Stack
            </Link> */}
          </div>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
